<!--
 * @Author: your name
 * @Date: 2021-10-11 13:32:54
 * @LastEditTime: 2021-10-11 14:55:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/arkHome/components/chatType.vue
-->
<!--  -->
<template>
  <div>
    <div class="cover">
      <div class="box">
        <img
          class="top"
          src="@/assets/img/loginImg/chat.png"
          alt=""
        />
        <img
          @click="hidePanel"
          class="close"
          src="@/assets/img/loginImg//chatClose.png"
          alt=""
        />
        <h1>请选择咨询类型</h1>
        <p>我们会为您提供更快捷有效的咨询服务</p>
        <div>
          <button
            id="customBtn"
            class="chat zhiCustomBtn"
            @click="openAdvisory(1)"
          >
            课程购买
          </button>
          <button
            class="chat"
            @click="openAdvisory(2)"
          >售后咨询</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    hidePanel() {
      this.$emit('closeAdvisory', 1);
    },
    openAdvisory(state) {
      if (state === 1) {
        // const { showType } = this.$parent.$options.propsData.courseTabDetails;
        const showType = this.$parent?.$options?.propsData?.courseTabDetails?.showType || 0;
        if (showType === 4) {
          this.openUrl(
            'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=619eeb541619434b59478ee3',
          );
        } else {
          this.openUrl(
            'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=6194a29668991d6b4e202137',
          );
        }
      } else {
        this.openUrl(
          `https://iqihang.sobot.com/chat/h5/v2/index.html?sysnum=ba284951843a4490afb0719b16367967&channelid=3&partnerid=${this.userInfo.id || ''}`,
        );
      }
      this.$emit('closeAdvisory', 1);
    },
    openUrl(url) {
      if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      window.open(url);
    },
  },
  created() { },
  mounted() { },
};
</script>
<style lang="scss" scoped>
.cover {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  .box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 540px;
    height: 600px;
    background: #fff;
    border-radius: 20px;
    transform: translate(-50%, -50%);
    .top {
      width: 100%;
    }
    .close {
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 100;
      width: 40px;
    }
    h1 {
      padding-top: 20px;
      color: #374a5f;
      font-weight: bold;
      font-size: 36px;
      line-height: 100px;
      text-align: center;
    }
    p {
      padding-bottom: 32px;
      color: #8e97a3;
      font-size: 24px;
      text-align: center;
    }
    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 0 56px;
      button {
        width: 200px;
        height: 68px;
        color: #fff;
        font-size: 28px;
        line-height: 68px;
        text-align: center;
        background: #ff6c02;
        border-radius: 50px;
      }
    }
  }
}
</style>
